export const EVERYONE = 'EVERYONE'
export const INVISIBLE = 'INVISIBLE'
export const CHANGE_VISIBILITY =
  'containers/mainPanel/visibility/CHANGE_VISIBILITY'
export const CHANGE_VISIBILITY_SUCCESS =
  'containers/mainPanel/visibility/CHANGE_VISIBILITY_SUCCESS'
